// extracted by mini-css-extract-plugin
export default {"panelBody":"Tabs_panelBody__XYkrl","tabHeading":"Tabs_tabHeading__r5jcx","navTabs":"Tabs_navTabs__Qg2gP","tab":"Tabs_tab__KS7s9","tabPanel":"Tabs_tabPanel__b2En6"};